export default {
  setData(state, { payload }) {
    state.allData = payload.data.list;
  },
  setDataDetail(state, { payload }) {
    state.dataDetail = payload.data;
  },
  setItem(state, { payload }) {
    state.item = payload.data.data;
  },
  clearData(state) {
    state.allData = [];
    state.totalData = 0;
  },
  clearErrors(state) {
    state.errors = [];
  },
  setErrors(state, payload) {
    state.errors = payload;
  },
  setTotalData(state, { payload }) {
    state.totalData = parseInt(payload.data.countdata, 10);
    state.totalPage = parseInt(payload.data.totalpage, 10);
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setCancelation(state, payload) {
    state.requestData = payload;
  },
  setLoadingGenerate(state, loadingGenerate) {
    state.loadingGenerate = loadingGenerate;
  },
  setPairKey(state, { payload }) {
    state.dataDetail = payload.data;
  },
};
